<template>
  <div>
      <div class="container">
        <h1 class="page-header">
               <span>Our
                 <span class="orange-link">Story</span></span>
          <hr/>
        </h1>
        <div class="title-intro">
          <p>Friday & Co Estate Agents was founded in 2025 with a simple vision: to provide homeowners with a modern, honest and results-driven estate agency built around exceptional customer service.
Proudly based in Lowestoft, we specialise in helping people buy and sell property across Lowestoft, Oulton Broad, Carlton Colville, Pakefield, Kessingland and the surrounding Suffolk and Norfolk areas. Our team combines extensive property knowledge with innovative marketing, expert negotiation and a personal approach that puts our clients first.
We understand that moving home is one of life's biggest decisions, which is why we take the time to understand your goals, communicate openly throughout the process and work tirelessly to achieve the best possible outcome. From accurate valuations and professional marketing to managing viewings, negotiating offers and progressing your sale through to completion, we're with you every step of the way.
As an independent local estate agency, we're passionate about our community and committed to raising the standard of estate agency through honest advice, transparent pricing and a genuine dedication to delivering outstanding results.
</p>
        </div>
        <h2>Meet the Team</h2>
        <hr />
        <div class="team-member">
          <h3>Andrew Friday DipFA – Founder & Director</h3>
          <p>Founder of <strong>Friday Financial Services</strong> and <strong>Friday & Co Estate Agents</strong>, Andrew is a professionally qualified financial adviser and property expert with over 20 years' experience in the property and financial services industries.
After spending many years working within high street banks, Andrew's ambition and entrepreneurial drive led him to establish Friday Financial Services in 2015. Building on that success, he launched Friday & Co Estate Agents in 2025, combining his extensive mortgage expertise with a modern, customer-focused approach to estate agency.
Born and raised in Lowestoft, Andrew has developed an exceptional understanding of the local property market and has successfully helped hundreds of clients buy, sell and finance their homes. His honest advice, strong negotiation skills and innovative marketing strategies have earned him a reputation for delivering outstanding results while making the moving process as straightforward and stress-free as possible.
Andrew's passion for exceptional customer service and commitment to achieving the very best outcome for every client continue to drive the success of both businesses, helping Friday Financial Services retain its reputation as one of Lowestoft's highest-rated mortgage firms whilst establishing Friday & Co as a trusted name in the local property market.
</p>
          <img src="~@/assets/images/staff-images/andrew.png" alt="Andrew Friday Image"/>
        </div>
        
        <div class="team-member">
          <h3>Lily Buckingham – Sales Negotiator & Mortgage Administrator</h3>
          <p>Lily is the newest member of the Friday & Co team and plays an important role across both our estate agency and mortgage departments. As Sales Negotiator and Mortgage Administrator, she is dedicated to providing exceptional customer service and ensuring every client enjoys a smooth and stress-free experience.
From helping buyers and sellers throughout their property journey to supporting mortgage applications from start to finish, Lily works closely with clients, solicitors, estate agents, lenders and other professionals to keep transactions progressing efficiently. Her proactive approach, excellent communication skills and keen attention to detail ensure clients are kept informed every step of the way.
Whether arranging viewings, negotiating sales, coordinating paperwork or assisting with mortgage administration, Lily is committed to delivering a friendly, professional service and helping every move reach a successful conclusion.
</p>
          <img src="~@/assets/images/staff-images/lily.jpg" alt="Lily Buckingham Image"/>
        </div>
      </div>
      <div class="cta">
        <div class="container">
          <div class="row d-flex align-items-center justify-content-between">
            <h2 class="mb-0 d-flex justify-content-center">
              <strong>Get In Touch</strong>
            </h2>
            <p>Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss your options, we can schedule a time best suited to you.</p>
            <div class="d-flex justify-content-end align-items-center">
              <router-link to="/contact-us/" class="btn btn-orange btn-block">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name : "selling-with-us"
}
</script>



<style lang="css">


</style>



// WEBPACK FOOTER //
// src/components/pages/OurStory.vue